import { render, staticRenderFns } from "./ForExam.vue?vue&type=template&id=20799e1c&scoped=true"
import script from "./ForExam.vue?vue&type=script&lang=js"
export * from "./ForExam.vue?vue&type=script&lang=js"
import style0 from "./ForExam.vue?vue&type=style&index=0&id=20799e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20799e1c",
  null
  
)

export default component.exports